/* Related Blogs Carousel
   File: assets/related-blogs-carousel.js
   Loaded from theme.liquid, initialises every [data-rbc-feed] section on the page. */
(function () {
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function cardHtml(a) {
    var media = a.image
      ? '<img src="' + esc(a.image) + '" alt="' + esc(a.alt) + '" width="700" height="466" loading="lazy">'
      : '<span class="rbc-card__placeholder"></span>';
    return '<article class="rbc-card"><a class="rbc-card__link" href="' + esc(a.url) + '">' +
      '<div class="rbc-card__media">' + media + '</div>' +
      '<div class="rbc-card__body">' +
      '<h3 class="rbc-card__title">' + esc(a.title) + '</h3>' +
      '<p class="rbc-card__excerpt">' + esc(a.excerpt) + '</p>' +
      '<div class="rbc-card__foot"><span class="rbc-card__date">' + esc(a.date) + '</span>' +
      '<span class="rbc-card__more">Read &rarr;</span></div>' +
      '</div></a></article>';
  }

  function init(root) {
    if (!root || root.dataset.rbcInit) return;
    root.dataset.rbcInit = '1';

    var track = root.querySelector('[data-rbc-track]');
    var prev = root.querySelector('[data-rbc-prev]');
    var next = root.querySelector('[data-rbc-next]');
    var nav = root.querySelector('.rbc__nav');
    var limit = parseInt(root.dataset.rbcLimit, 10) || 6;
    if (!track) return;

    function step() {
      var card = track.querySelector('.rbc-card');
      if (!card) return track.clientWidth;
      var cs = getComputedStyle(track);
      var gap = parseInt(cs.columnGap || cs.gap, 10) || 24;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      if (nav) nav.style.display = max <= 2 ? 'none' : 'flex';
    }

    if (prev) prev.addEventListener('click', function () { track.scrollLeft -= step(); });
    if (next) next.addEventListener('click', function () { track.scrollLeft += step(); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    var delay = parseInt(root.dataset.rbcAutoplay, 10);
    if (isNaN(delay)) delay = 5000;
    var timer = null;

    function advance() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 2) return;
      if (track.scrollLeft >= max - 4) {
        track.scrollLeft = 0;
      } else {
        track.scrollLeft += step();
      }
    }

    function play() {
      if (timer || delay <= 0) return;
      timer = setInterval(advance, delay);
    }

    function pause() {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    }

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', pause);
    root.addEventListener('touchstart', pause, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { pause(); } else { play(); }
    });

    var urls = (root.dataset.rbcFeed || '').split(',').filter(function (u) { return u.trim(); });
    if (!urls.length) return;

    Promise.all(urls.map(function (u) {
      return fetch(u.trim(), { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.text(); })
        .then(function (t) { return JSON.parse(t).articles || []; })
        .catch(function () { return []; });
    })).then(function (groups) {
      var seen = {};
      var merged = [];
      groups.forEach(function (g) {
        g.forEach(function (a) {
          if (a && a.url && !seen[a.url]) { seen[a.url] = 1; merged.push(a); }
        });
      });
      merged.sort(function (a, b) { return (b.ts || 0) - (a.ts || 0); });
      var list = merged.slice(0, limit);

      if (!list.length) {
        if (!track.querySelector('.rbc-card')) root.remove();
        return;
      }
      track.innerHTML = list.map(cardHtml).join('');
      root.removeAttribute('hidden');
      play();
    }).then(function () { setTimeout(update, 150); });
  }

  function scan() {
    var nodes = document.querySelectorAll('[data-rbc-feed]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  setTimeout(scan, 1200);
  setTimeout(scan, 3000);
})();
